import styled from 'styled-components';

export const StyledCardContainer = styled.div`
    gap: 24px;
    display: grid;
    align-items: stretch;
    grid-template-columns: repeat(2, 1fr); /* 2 cards per row */
    @media (max-width: 926px) {
        grid-template-columns: 1fr;
    }
`;

export const StyledRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    align-self: flex-end;
`;

export const StyledRowBetween = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    @media (max-width: 926px) {
        flex-wrap: wrap;
        align-items: flex-start;
    }
`;

export const StyledButton = styled.div`
    display: flex;
    padding: 8px 16px;
    font-size: 16px;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;

export const StyledBenefitCard = styled.div<{ selected: boolean }>(
    (p) => `
  background: ${p.selected ? p.theme.colors.mutedTransparent : p.theme.colors.white};
  border: 1px solid ${p.selected ? p.theme.colors.loopEmerald : p.theme.colors.seafoamGray};
  display: flex;
  padding: 20px;
  gap: 20px;
  min-height: 180px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 12px;
`
);

export const StyledLockInCard = styled.div`
    display: flex;
    flex: 1;
`;

export const StyledHeader = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
`;

export const StyledHeaderText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const StyledImageContainer = styled.img(
    (p) => `
    width: ${p.width ? p.width : '100%'};
    height: ${p.height ? p.height : '100%'};
`
);

export const StyledDetails = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;
`;

export const StyledDropDown = styled.div`
    min-width: 220px;
    padding-left: 24px;
    @media (max-width: 926px) {
        padding-left: 0;
    }
`;

export const StyledDropDownContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 24px;
    border-left: 1px solid ${(p) => p.theme.colors.seafoamGray};
    min-height: 48px;
    @media (max-width: 926px) {
        padding-left: 0;
        border-left: none;
    }
`;

export const StyledRowPremiumPrice = styled.div<{ selected: boolean; $forceRow?: boolean }>(
    (p) => `
  display: flex;
  flex-direction: ${p.$forceRow ? 'row' : (p.selected ? 'column' : 'row')};
  align-items: ${p.$forceRow ? 'center' : (p.selected ? 'flex-start' : 'center')};
  gap: ${p.$forceRow ? '8px' : (p.selected ? '4px' : '8px')} ;
  flex-wrap: wrap;
`
);

export const StyledBenefitParentContainer = styled.div`
    flex-direction: column;
    display: flex;
    gap: 36px;
    padding: 36px 72px;
`;

export const StyledEmailInfo = styled.div`
    display: flex;
    align-items: flex-start;
    background-color: ${(p) => p.theme.colors.white};
    padding: 10px 24px;
    border-radius: 8px;
    gap: 8px;
`;

export const StyledEmailInfoIcon = styled.img`
    width: 22px;
`;

export const StyledEmailEditIcon = styled.img`
    width: 18px;
    position: relative;
    margin-left: 8px;
    top: 2px;
    cursor: pointer;
`;

export const StyledBenefitDescription = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    & > button {
        width: fit-content;
    }
`;

export const StyledPremiumAndDisclaimer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const StyledBenefitCardDisclaimer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    padding: 8px 12px;
    background-color: ${(p) => p.theme.colors.surface0};
    max-width: 408px;
`;

export const StyledBenefitPerLifeStatus = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: ${(p) => p.theme.colors.surface0};
    padding: 8px 12px;
    border-radius: 8px;
    align-self: flex-end;
`;

export const StyledBenefitEligibleMembers = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const StyledBenefitsEligibleMember = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
`;

export const StyledBenefitsEligibleMemberText = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledBenefitPerLifeSelectionModal = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 840px;
    border-radius: 12px;
`;

export const StyledBenefitPerLifeSelectionModalHeader = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 20px 24px 20px;
    background: linear-gradient(to right, ${(p) => p.theme.colors.loopEmerald}, #009577);
    border-radius: 8px 8px 0 0;
`;

export const StyledBenefitPerLifeSelectionModalHeaderText = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const StylePerLifeUserLogoHeaders = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
`;

export const StyledBenefitPrimaryInfo = styled.div`
    display: flex;
    flex-direction: row;
    height: 52px;
    border-radius: 12px;
    align-items: center;
    gap: 12px;
    max-width: 284px;
    padding: 8px 16px 8px 8px;
    background-color: ${(p) => p.theme.colors.surface0};
`;

export const StyledBenefitPrimaryIcon = styled.img`
    width: 36px;
    height: 36px;
    aspect-ratio: 1 / 1;
    border-radius: 6px;
`;

export const StyledBenefitPerLifeSelectionModalBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 20px;
    min-width: min(840px, 72px);
`;

export const StyledBenefitPerLifeSelectionModalBodyList = styled.div<{ $total: number }>`
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-height: 40vh;
    overflow-y: ${(p) => (p.$total > 4 ? 'auto' : 'visible')};
`;

export const StyledBenefitPerLifeSelectionModalBodyStepTwo = styled.div<{ $total: number }>`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 800px;
    border-radius: 12px;
`;

export const StyledBnenefitPerLifeScrollContainer = styled.div<{ $total: number }>`
    display: flex;
    flex-direction: row;
    overflow-y: ${(p) => (p.$total > 3 ? 'auto' : 'visible')};
    gap: 16px;
    scroll-behavior: smooth;
`;

export const StyledBenefitPerLifeSelectionModalUncovered = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    border-radius: 8px;
    background-color: ${(p) => p.theme.colors.surface0};
`;

export const StyledBenefitPerLifeSelectionModalFooter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-top: 0.5px solid ${(p) => p.theme.colors.seafoamGray};
    padding: 16px 24px 16px 24px;
`;

export const StyledBenefitPerLifeSelectionModalFooterLeft = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const StyledBenefitPerLifeSelectionModalFooterRight = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
    justify-content: flex-end;
`;

export const StyledBenefitPerLifeSelectionModalFooterError = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const StyledBenefitPerLifeMemberWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
`;

export const StyledBenefitPerLifeMember = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;
export const StyledBenefitPerLifeMemberCheckbox = styled.input`
    accent-color: ${(p) => p.theme.colors.loopEmerald};
    width: 20px;
    height: 20px;
    cursor: pointer;
`;

export const StyledBenefitPerLifeSelected = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    border-radius: 8px;
    border: 1px solid ${(p) => p.theme.colors.seafoamGray};
    background-color: ${(p) => p.theme.colors.white};
    cursor: pointer;
    align-self: flex-end;
`;

export const StyledBenefitPerLifeRemovalModal = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 500px;
`;

export const StyledBenefitPerLifeRemovalModalBody = styled.div`
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    box-sizing: border-box;
    align-items: center;
`;

export const StyledBenefitPerLifeRemovalModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-radius: 8px;
    padding: 12px 16px;
    text-align: start;
    width: 100%;
    box-sizing: border-box;
    background-color: ${(p) => p.theme.colors.surface0};
`;

export const StyledBenefitPerLifeRemovalModalFooter = styled.div`
    display: flex;
    gap: 24px;
    align-items: center;
    padding: 16px 32px;
    border-top: 0.5px solid ${({ theme }) => theme.colors.seafoamGray};
`;

export const StyledNonPerLifeModal = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    min-width: 840px;
`;

export const StyledNonPerLifeHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: ${(p) => p.theme.colors.loopEmerald};
    border-radius: 8px 8px 0 0;
    padding: 20px;
    background: linear-gradient(to right, ${(p) => p.theme.colors.loopEmerald}, #009577);
    position: relative;
`;

export const StyledNonPerLifeHeaderTitle = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const StyledNonPerLifeBenefitCard = styled.div`
    display: flex;
    align-items: center;
    padding-right: 16px;
    padding-left: 8px;
    padding-top: 8px;
    padding-bottom: 8px;
    background-color: white;
    border-radius: 12px;
    gap: 16px;
    border: 1px;
    max-width: 319px;
    max-height: 52px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
`;

export const StyledNonPerLifeIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 284px;
    min-height: 40px;
    border-radius: 4px;
`;

export const StyledNonPerLifeIcon = styled.img`
    width: 36px;
    height: 36px;
`;

export const StyledNonPerLifeBody = styled.div`
    padding: 20px 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    /* Changed min-height to auto to adjust based on content */
    height: auto;
    scroll-behavior: smooth;
`;

export const StyledNonPerLifeSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-width: 800px;
    background-color: ${(p) => p.theme.colors.surface0};
    transition: height 0.2s ease-in-out;
    border-radius: 12px;
`;

export const StyledDivider = styled.div`
    height: 1px;
    background-color: ${(p) => p.theme.colors.mutedTransparent};
    width: 100%;
    margin: 4px 0;
`;

export const StyledTotalPrice = styled.div`
    display: flex;
    flex-direction: row;
    border: 0cap.5px solid ${(p) => p.theme.colors.seafoamGray};
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px 16px 24px;
`;

// Create a grid layout for attributes
export const StyledFieldsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 16px;
    gap: 12px;
    & > div {
        flex: 1;
    }
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

export const StyledNonPerLifeSectionTier = styled.div`
    flex-direction: column;
    background-color: white;
    gap: 16px;
`;

export const StyledPlanSelectionContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
`;

export const StyledPlanDropdownWrapper = styled.div`
    min-width: 279px;
`;

export const StyledMemberCard = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    background-color: ${(p) => p.theme.colors.white};
`;

export const StyledMemberHeader = styled.div<{ $expanded?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 12px;
    box-shadow: 0px 2px 8px 0px #3741510f;
    position: relative;
    border: 1px solid ${(p) => p.theme.colors.mutedTransparent};
    border-radius: ${(props) => (props.$expanded ? '12px 12px 12px 12px' : '12px')};
`;

export const StyledMemberInfo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
`;

export const StyledMemberDetails = styled.div`
    display: flex;
    flex-direction: column;
    width: 172px;
`;

export const StyledExpandIcon = styled.img<{ $expanded: boolean }>`
    width: 24px;
    height: 24px;
    transform: ${(props) => (props.$expanded ? 'rotate(0deg)' : 'rotate(180deg)')};
    transition: transform 0.2s ease;
`;

export const StyledExpandedContent = styled.div`
    background-color: ${(p) => p.theme.colors.surface0};
    border-radius: 12px;
`;
